import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-32 text-center">
        <h1 className="font-display text-4xl mb-4">Post not found</h1>
        <Link to="/journal" className="btn-accent">Back to journal</Link>
      </div>
    );
  }
  if (!post) return <div className="max-w-3xl mx-auto px-6 py-24 text-muted-foreground">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 md:px-10 py-16">
      <Link to="/journal" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8">
        <ArrowLeft className="w-4 h-4" /> Back to journal
      </Link>
      <div className="label-eyebrow mb-3 text-[#C95B3B]">{post.tag}</div>
      <h1 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight mb-6" data-testid="post-title">{post.title}</h1>
      <p className="text-sm text-muted-foreground mb-10">By {post.author} · {new Date(post.published_at).toLocaleDateString()}</p>
      {post.image_url && (
        <div className="aspect-[16/9] overflow-hidden border border-border mb-10">
          <img src={post.image_url} alt={post.title} className="w-full h-full object-cover" />
        </div>
      )}
      <div className="prose max-w-none text-lg leading-relaxed whitespace-pre-wrap">
        {post.body}
      </div>
    </article>
  );
}
